(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  function initializeCartPage(section) {
    if (section.dataset.cartReady === 'true') return;
    section.dataset.cartReady = 'true';

    section.querySelectorAll('[data-cart-quantity]').forEach((control) => {
      const input = control.querySelector('[data-cart-quantity-input]');
      const minus = control.querySelector('[data-cart-minus]');
      const plus = control.querySelector('[data-cart-plus]');
      if (!input || !minus || !plus) return;

      const minimum = Number(control.dataset.quantityMin) || 1;
      const increment = Number(control.dataset.quantityIncrement) || 1;
      const maximum = Number(control.dataset.quantityMax) || null;

      const setQuantity = (requestedValue) => {
        const steppedValue = minimum + Math.round((requestedValue - minimum) / increment) * increment;
        const nextValue = maximum
          ? Math.min(Math.max(steppedValue, minimum), maximum)
          : Math.max(steppedValue, minimum);
        input.value = String(nextValue);
        minus.disabled = nextValue <= minimum;
        plus.disabled = maximum ? nextValue >= maximum : false;
      };

      minus.addEventListener('click', () => setQuantity(Number(input.value) - increment));
      plus.addEventListener('click', () => setQuantity(Number(input.value) + increment));
      input.addEventListener('change', () => setQuantity(Number(input.value) || minimum));
    });

  }

  document.querySelectorAll('.cart-page').forEach(initializeCartPage);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.cart-page').forEach(initializeCartPage);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-signup-dialog"]) return;
  try {
    
  (() => {
    if (window.stoneRootsEmailDialogInitialized) return;
    window.stoneRootsEmailDialogInitialized = true;

    const storageKey = 'stone-roots-email-dialog-v1';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const readState = () => {
      try {
        return JSON.parse(window.localStorage.getItem(storageKey) || '{}');
      } catch (_error) {
        return {};
      }
    };

    const writeState = (state) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(state));
      } catch (_error) {
        // The dialog still works when storage is unavailable.
      }
    };

    const markDismissed = (dialog) => {
      const days = Number.parseInt(dialog.dataset.dismissalDays, 10) || 7;
      writeState({
        ...readState(),
        dismissedUntil: Date.now() + days * 86400000
      });
    };

    const markSubscribed = () => writeState({
      ...readState(),
      subscribed: true
    });

    const openDialog = (dialog) => {
      if (dialog.open) return;
      dialog.showModal();
      document.documentElement.classList.add('email-dialog-open');
      window.requestAnimationFrame(() => dialog.classList.add('is-open'));
    };

    const closeDialog = (dialog, shouldDismiss = true) => {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      if (shouldDismiss && !dialog.querySelector('[data-email-signup-success]:not([hidden])')) {
        markDismissed(dialog);
      }

      dialog.classList.add('is-closing');
      dialog.classList.remove('is-open');

      const finish = () => {
        dialog.close();
        dialog.classList.remove('is-closing');
        document.documentElement.classList.remove('email-dialog-open');
      };

      if (reducedMotion.matches) {
        finish();
      } else {
        window.setTimeout(finish, 160);
      }
    };

    const initializeDialog = (dialog) => {
      if (dialog.dataset.initialized === 'true') return;
      dialog.dataset.initialized = 'true';
      const heading = dialog.querySelector('[id^="EmailSignupDialogTitle-"]');
      const text = dialog.querySelector('.email-dialog__text');
      dialog.dataset.defaultHeading = heading?.textContent || '';
      dialog.dataset.defaultText = text?.textContent.trim() || '';
      dialog.dataset.defaultSource = dialog.dataset.emailSignupSource || 'shopify_email_dialog';
      dialog.dataset.defaultButtonLabel = dialog.querySelector('[data-email-signup-submit] span')?.textContent.trim() || '';
      dialog.dataset.defaultConsent = dialog.querySelector('.email-dialog__consent')?.textContent.trim() || '';
      dialog.dataset.defaultSuccessHeading = dialog.querySelector('.email-dialog__success h2')?.textContent.trim() || '';
      dialog.dataset.defaultSuccessText = dialog.querySelector('.email-dialog__success p')?.textContent.trim() || '';

      dialog.querySelectorAll('[data-email-dialog-close]').forEach((button) => {
        button.addEventListener('click', () => closeDialog(dialog));
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog(dialog);
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog(dialog);
      });

      dialog.addEventListener('close', () => {
        dialog.classList.remove('is-open', 'is-closing');
        document.documentElement.classList.remove('email-dialog-open');
      });

      const state = readState();
      const designMode = dialog.dataset.designMode === 'true';
      const enabled = dialog.dataset.enabled === 'true';
      if (!enabled || designMode || state.subscribed || state.dismissedUntil > Date.now()) return;

      const delay = (Number.parseInt(dialog.dataset.delaySeconds, 10) || 0) * 1000;
      window.setTimeout(() => {
        const currentState = readState();
        if (!currentState.subscribed && !(currentState.dismissedUntil > Date.now()) && document.documentElement.dataset.localizationPromptShown !== 'true') {
          openDialog(dialog);
        }
      }, delay);
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-email-dialog]').forEach(initializeDialog);
      root.querySelectorAll('[data-email-dialog-open]').forEach((trigger) => {
        if (trigger.dataset.emailDialogTriggerReady === 'true') return;
        trigger.dataset.emailDialogTriggerReady = 'true';
        trigger.addEventListener('click', () => {
          const dialog = document.querySelector('[data-email-dialog]');
          if (!dialog) return;
          initializeDialog(dialog);
          const heading = dialog.querySelector('[id^="EmailSignupDialogTitle-"]');
          const text = dialog.querySelector('.email-dialog__text');
          if (heading) {
            heading.textContent = trigger.dataset.emailDialogHeading || dialog.dataset.defaultHeading;
          }
          if (text) {
            const paragraph = text.querySelector('p') || document.createElement('p');
            paragraph.textContent = trigger.dataset.emailDialogText || dialog.dataset.defaultText;
            text.replaceChildren(paragraph);
          }
          const buttonLabel = dialog.querySelector('[data-email-signup-submit] span');
          const consent = dialog.querySelector('.email-dialog__consent');
          const successHeading = dialog.querySelector('.email-dialog__success h2');
          const successText = dialog.querySelector('.email-dialog__success p');
          if (buttonLabel) buttonLabel.textContent = trigger.dataset.emailDialogButtonLabel || dialog.dataset.defaultButtonLabel;
          if (consent) consent.textContent = trigger.dataset.emailDialogConsent || dialog.dataset.defaultConsent;
          if (successHeading) successHeading.textContent = trigger.dataset.emailDialogSuccessHeading || dialog.dataset.defaultSuccessHeading;
          if (successText) successText.textContent = trigger.dataset.emailDialogSuccessText || dialog.dataset.defaultSuccessText;
          dialog.dataset.emailSignupSource = trigger.dataset.emailDialogSource || dialog.dataset.defaultSource;
          openDialog(dialog);
          window.requestAnimationFrame(() => {
            dialog.querySelector('[data-email-signup-input]')?.focus({ preventScroll: true });
          });
        });
      });
    };

    document.addEventListener('stone-roots:email-signup-success', () => {
      markSubscribed();
    });

    document.addEventListener('stone-roots:email-dialog-open-success', (event) => {
      const dialog = document.querySelector('[data-email-dialog]');
      if (!dialog) return;
      if (event.detail?.source === 'shopify_home_workshop_dialog') {
        const heading = dialog.querySelector('.email-dialog__success h2');
        const text = dialog.querySelector('.email-dialog__success p');
        if (heading) heading.textContent = dialog.dataset.workshopSuccessHeading;
        if (text) text.textContent = dialog.dataset.workshopSuccessText;
      } else if (event.detail?.source === 'shopify_home_pager') {
        const heading = dialog.querySelector('.email-dialog__success h2');
        const text = dialog.querySelector('.email-dialog__success p');
        if (heading) heading.textContent = dialog.dataset.pagerSuccessHeading;
        if (text) text.textContent = dialog.dataset.pagerSuccessText;
      }
      openDialog(dialog);
    });

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      const dialog = event.target.querySelector('[data-email-dialog]');
      if (dialog) openDialog(dialog);
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      const dialog = event.target.querySelector('[data-email-dialog]');
      if (dialog) closeDialog(dialog, false);
    });

    initializeAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-producer-videos"] && !Shopify.designMode) return;
  try {
    
  function initHomeProducerVideos(scope = document) {
    scope.querySelectorAll('.home-producer-videos').forEach((section) => {
      if (section.dataset.carouselReady === 'true') return;
      section.dataset.carouselReady = 'true';

      const track = section.querySelector('[data-carousel-track]');
      const cards = [...track.querySelectorAll('.home-producer-videos__card')];
      const nav = section.querySelector('[data-carousel-nav]');
      const previous = section.querySelector('[data-carousel-previous]');
      const next = section.querySelector('[data-carousel-next]');
      let dragStartX = 0;
      let dragStartScroll = 0;

      function cardStep() {
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return cards[0].getBoundingClientRect().width + gap;
      }

      function updateNav() {
        const maxScroll = track.scrollWidth - track.clientWidth;
        nav.hidden = maxScroll < 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll - 2;

        const visibleArea = track.getBoundingClientRect();
        cards.forEach((card) => {
          const video = card.querySelector('video');
          if (!video || video.paused) return;
          const bounds = card.getBoundingClientRect();
          const visibleWidth = Math.max(0, Math.min(bounds.right, visibleArea.right) - Math.max(bounds.left, visibleArea.left));
          if (visibleWidth < bounds.width / 2) video.pause();
        });
      }

      if (cards.length) {
        previous.addEventListener('click', () => track.scrollBy({ left: -cardStep(), behavior: 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: cardStep(), behavior: 'smooth' }));
        track.addEventListener('scroll', updateNav, { passive: true });
        window.addEventListener('resize', updateNav);
        updateNav();
      } else {
        nav.hidden = true;
      }

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.target.closest('video, button')) return;
        dragStartX = event.clientX;
        dragStartScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });
      track.addEventListener('pointermove', (event) => {
        if (!track.classList.contains('is-dragging')) return;
        track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
      });
      function stopDragging() {
        track.classList.remove('is-dragging');
      }
      track.addEventListener('pointerup', stopDragging);
      track.addEventListener('pointercancel', stopDragging);
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        if (!cards.length) return;
        track.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * cardStep(), behavior: 'smooth' });
      });

      cards.forEach((card) => {
        const video = card.querySelector('video');
        const button = card.querySelector('.home-producer-videos__play');
        if (!video || !button) return;

        button.addEventListener('click', () => {
          section.querySelectorAll('video').forEach((other) => {
            if (other !== video) other.pause();
          });
          video.controls = true;
          const playRequest = video.play();
          if (playRequest) playRequest.catch(() => { video.controls = false; });
        });
        video.addEventListener('play', () => { button.hidden = true; });
        video.addEventListener('pause', () => { button.hidden = false; });
      });
    });
  }

  initHomeProducerVideos();
  document.addEventListener('shopify:section:load', (event) => initHomeProducerVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.main-product').forEach((section) => {
    const primaryImage = section.querySelector('.main-product__primary-image');
    const thumbnailList = section.querySelector('.main-product__thumbs');
    const thumbnails = Array.from(section.querySelectorAll('.main-product__thumb'));
    const previousButton = section.querySelector('[data-gallery-previous]');
    const nextButton = section.querySelector('[data-gallery-next]');
    const thumbnailPageSize = 4;
    let dragStartX = null;
    let dragDistance = 0;
    let suppressThumbnailClick = false;

    const updateThumbnailWindow = (activeIndex) => {
      const maximumStart = Math.max(thumbnails.length - thumbnailPageSize, 0);
      const windowStart = Math.min(Math.max(activeIndex - 2, 0), maximumStart);
      const windowEnd = windowStart + thumbnailPageSize;

      thumbnails.forEach((thumbnail, index) => {
        thumbnail.hidden = index < windowStart || index >= windowEnd;
      });
    };

    const selectThumbnail = (index) => {
      if (!primaryImage || thumbnails.length === 0) return;

      const normalizedIndex = (index + thumbnails.length) % thumbnails.length;
      const thumbnail = thumbnails[normalizedIndex];
      primaryImage.src = thumbnail.dataset.imageSrc;
      primaryImage.removeAttribute('srcset');
      thumbnails.forEach((item) => item.classList.remove('is-active'));
      thumbnail.classList.add('is-active');
      updateThumbnailWindow(normalizedIndex);
    };

    updateThumbnailWindow(0);

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        if (suppressThumbnailClick) return;
        selectThumbnail(index);
      });
    });

    const finishThumbnailDrag = (event, shouldSelect) => {
      if (dragStartX === null || !thumbnailList) return;

      const threshold = Math.min(64, thumbnailList.clientWidth * 0.12);
      const crossedThreshold = Math.abs(dragDistance) >= threshold;

      if (shouldSelect && crossedThreshold) {
        thumbnailList.style.removeProperty('--thumbnail-drag-offset');
        const activeIndex = thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active'));
        suppressThumbnailClick = true;
        selectThumbnail(activeIndex + (dragDistance < 0 ? 1 : -1));
        window.setTimeout(() => {
          suppressThumbnailClick = false;
        }, 0);
        thumbnailList.classList.remove('is-dragging');
      } else {
        thumbnailList.classList.remove('is-dragging');
        thumbnailList.style.removeProperty('--thumbnail-drag-offset');
      }

      if (event.pointerId !== undefined && thumbnailList.hasPointerCapture(event.pointerId)) {
        thumbnailList.releasePointerCapture(event.pointerId);
      }

      dragStartX = null;
      dragDistance = 0;
    };

    thumbnailList?.addEventListener('pointerdown', (event) => {
      if (event.button !== 0 || thumbnails.length < 2) return;

      dragStartX = event.clientX;
      dragDistance = 0;
      thumbnailList.classList.add('is-dragging');
    });

    thumbnailList?.addEventListener('pointermove', (event) => {
      if (dragStartX === null) return;

      dragDistance = event.clientX - dragStartX;
      if (Math.abs(dragDistance) > 6 && !thumbnailList.hasPointerCapture(event.pointerId)) {
        thumbnailList.setPointerCapture(event.pointerId);
      }
      const resistedDistance = dragDistance * 0.55;
      thumbnailList.style.setProperty('--thumbnail-drag-offset', `${resistedDistance}px`);
    });

    thumbnailList?.addEventListener('pointerup', (event) => {
      finishThumbnailDrag(event, true);
    });

    thumbnailList?.addEventListener('pointercancel', (event) => {
      finishThumbnailDrag(event, false);
    });

    previousButton?.addEventListener('click', () => {
      const activeIndex = thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active'));
      selectThumbnail(activeIndex - 1);
    });

    nextButton?.addEventListener('click', () => {
      const activeIndex = thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active'));
      selectThumbnail(activeIndex + 1);
    });

    const select = section.querySelector('select[name="id"]');
    const purchaseControls = section.querySelector('[data-purchase-controls]');
    const quantityControl = section.querySelector('[data-quantity-control]');
    const quantityValue = quantityControl?.querySelector('[data-quantity-value]');
    const quantityMinus = quantityControl?.querySelector('[data-quantity-minus]');
    const quantityPlus = quantityControl?.querySelector('[data-quantity-plus]');
    const submit = section.querySelector('.main-product__submit');
    const submitLabel = section.querySelector('[data-submit-label]');
    const submitPrices = section.querySelector('.main-product__submit-prices');
    const submitPrice = section.querySelector('[data-submit-price]');
    const priceDetail = section.querySelector('[data-price-detail]');
    const priceDivider = section.querySelector('[data-price-divider]');
    let quantityMinimum = Number(quantityControl?.dataset.quantityMin) || 1;
    let variantQuantityMaximum = Number(quantityControl?.dataset.quantityMax) || null;
    let quantityMaximum = variantQuantityMaximum;
    let quantityIncrement = Number(quantityControl?.dataset.quantityIncrement) || 1;
    let variantAvailable = quantityControl?.dataset.available === 'true';
    let quantityAvailable = variantAvailable;
    let cartVariantQuantity = Number(section.dataset.cartVariantQuantity) || 0;
    let unitPriceCents = Number(submit?.dataset.unitPriceCents) || 0;

    const moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: section.dataset.currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });

    const updateSubmitTotal = () => {
      const quantity = Number(quantityValue?.value) || quantityMinimum;
      if (submitPrices) submitPrices.hidden = !quantityAvailable;
      if (submitPrice) submitPrice.textContent = moneyFormatter.format((unitPriceCents * quantity) / 100);
    };

    const updateCartLimit = () => {
      const remainingVariantQuantity = variantQuantityMaximum
        ? Math.max(variantQuantityMaximum - cartVariantQuantity, 0)
        : null;
      quantityMaximum = remainingVariantQuantity;
      const limitReached = variantQuantityMaximum !== null && remainingVariantQuantity <= 0;
      quantityAvailable = variantAvailable && !limitReached;

      if (quantityControl) quantityControl.hidden = !quantityAvailable;
      purchaseControls?.classList.toggle('main-product__purchase-controls--button-only', !quantityAvailable);
      if (submit) submit.disabled = !quantityAvailable;
      if (submitLabel) {
        submitLabel.textContent = limitReached
          ? `Maximum ${variantQuantityMaximum} in cart`
          : variantAvailable ? section.dataset.addLabel : section.dataset.soldLabel;
      }
      setQuantity(Number(quantityValue?.value) || quantityMinimum);
    };

    const setQuantity = (requestedValue) => {
      if (!quantityValue) return;

      const steppedValue = quantityMinimum
        + Math.round((requestedValue - quantityMinimum) / quantityIncrement) * quantityIncrement;
      let nextValue = Math.max(steppedValue, quantityMinimum);
      if (quantityMaximum) nextValue = Math.min(nextValue, quantityMaximum);
      quantityValue.value = String(nextValue);
      quantityValue.min = String(quantityMinimum);
      if (quantityMaximum) {
        quantityValue.max = String(quantityMaximum);
      } else {
        quantityValue.removeAttribute('max');
      }
      quantityValue.step = String(quantityIncrement);
      if (quantityMinus) quantityMinus.disabled = !quantityAvailable || nextValue <= quantityMinimum;
      if (quantityPlus) quantityPlus.disabled = !quantityAvailable || Boolean(quantityMaximum && nextValue >= quantityMaximum);
      updateSubmitTotal();
    };

    const updateQuantityControl = (option) => {
      if (!quantityControl || !quantityValue) return;

      quantityMinimum = Number(option.dataset.quantityMin) || 1;
      variantQuantityMaximum = Number(option.dataset.quantityMax) || null;
      quantityIncrement = Number(option.dataset.quantityIncrement) || 1;
      variantAvailable = option.dataset.available === 'true';
      cartVariantQuantity = Number(option.dataset.cartQuantity) || 0;
      updateCartLimit();
    };

    quantityMinus?.addEventListener('click', () => {
      setQuantity(Number(quantityValue?.value) - quantityIncrement);
    });

    quantityPlus?.addEventListener('click', () => {
      setQuantity(Number(quantityValue?.value) + quantityIncrement);
    });

    quantityValue?.addEventListener('change', () => {
      setQuantity(Number(quantityValue.value) || quantityMinimum);
    });

    quantityValue?.addEventListener('blur', () => {
      setQuantity(Number(quantityValue.value) || quantityMinimum);
    });

    updateCartLimit();

    document.addEventListener('stone-roots:cart-updated', (event) => {
      const items = event.detail?.cart?.items;
      if (!Array.isArray(items)) return;
      const selectedVariantId = select?.value || section.querySelector('input[name="id"]')?.value;
      cartVariantQuantity = items.reduce((total, item) => {
        return String(item.variant_id) === selectedVariantId ? total + item.quantity : total;
      }, 0);
      section.dataset.cartVariantQuantity = String(cartVariantQuantity);
      updateCartLimit();
    });

    if (!select) return;

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = option.dataset.price;
      const comparePrice = option.dataset.comparePrice;
      unitPriceCents = Number(option.dataset.priceCents) || 0;
      const available = option.dataset.available === 'true';
      const priceElement = section.querySelector('[data-product-price]');
      const compareElement = section.querySelector('[data-product-compare-price]');

      if (priceElement) priceElement.textContent = price;
      if (compareElement) {
        compareElement.textContent = comparePrice;
        compareElement.hidden = !comparePrice || comparePrice === price;
      }
      if (priceDetail) {
        const detail = option.dataset.priceDetail === 'Default Title' ? '' : option.dataset.priceDetail;
        priceDetail.textContent = detail;
        priceDetail.hidden = !detail;
        if (priceDivider) priceDivider.hidden = !detail;
      }
      updateQuantityControl(option);
      if (!available && submitLabel) submitLabel.textContent = section.dataset.soldLabel;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origin-story"] && !Shopify.designMode) return;
  try {
    
  function initOriginStoryVideos(scope = document) {
    scope.querySelectorAll('.origin-story__video').forEach((wrapper) => {
      if (wrapper.dataset.videoReady === 'true') return;

      const video = wrapper.querySelector('video');
      const playButton = wrapper.querySelector('.origin-story__play');
      if (!video || !playButton) return;

      wrapper.dataset.videoReady = 'true';

      playButton.addEventListener('click', () => {
        playButton.hidden = true;
        video.controls = true;
        const playRequest = video.play();
        if (playRequest) {
          playRequest.catch(() => {
            video.controls = false;
            playButton.hidden = false;
          });
        }
      });

      video.addEventListener('play', () => {
        playButton.hidden = true;
      });

      video.addEventListener('ended', () => {
        video.controls = false;
        playButton.hidden = false;
      });
    });
  }

  initOriginStoryVideos();
  document.addEventListener('shopify:section:load', (event) => {
    initOriginStoryVideos(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producer-interview"] && !Shopify.designMode) return;
  try {
    
  function initProducerInterviewVideos(scope = document) {
    scope.querySelectorAll('.producer-interview__video').forEach((wrapper) => {
      if (wrapper.dataset.videoReady === 'true') return;

      const video = wrapper.querySelector('video');
      const playButton = wrapper.querySelector('.producer-interview__play');
      if (!video || !playButton) return;

      wrapper.dataset.videoReady = 'true';

      playButton.addEventListener('click', () => {
        playButton.hidden = true;
        video.controls = true;
        const playRequest = video.play();
        if (playRequest) {
          playRequest.catch(() => {
            video.controls = false;
            playButton.hidden = false;
          });
        }
      });

      video.addEventListener('play', () => {
        playButton.hidden = true;
      });

      video.addEventListener('ended', () => {
        video.controls = false;
        playButton.hidden = false;
      });
    });
  }

  initProducerInterviewVideos();
  document.addEventListener('shopify:section:load', (event) => {
    initProducerInterviewVideos(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set-video-grid"] && !Shopify.designMode) return;
  try {
    
  function initSetVideos(scope = document) {
    scope.querySelectorAll('.set-video-grid__card').forEach((card) => {
      if (card.dataset.videoReady === 'true') return;

      const video = card.querySelector('video');
      const button = card.querySelector('.set-video-grid__play');
      if (!video || !button) return;

      card.dataset.videoReady = 'true';
      button.addEventListener('click', () => {
        button.hidden = true;
        video.controls = true;
        const playRequest = video.play();
        if (playRequest) {
          playRequest.catch(() => {
            video.controls = false;
            button.hidden = false;
          });
        }
      });

      video.addEventListener('play', () => {
        button.hidden = true;
      });

      video.addEventListener('ended', () => {
        video.controls = false;
        button.hidden = false;
      });
    });
  }

  initSetVideos();
  document.addEventListener('shopify:section:load', (event) => {
    initSetVideos(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
